import Vue from 'vue'
import Vuex from 'vuex'

import state from "./state"
import getters from "./getters"
import mutations from "./mutations"
import actions from "./actions"
import moduleAuth from './auth/moduleAuth.js'
import users from './user-management'
import settingCategories from './category-management'
import groups from './group-management'
import products from './product-management'
import shops from './eshops-management'
import dealers from './dealer-management'
import dashboard from './dashboard-management'
import cronJobs from './cron-jobs'
import reports from './reports'
import dynamicPricing from './dynamic-pricing'
import notifications from './notifications'
import admin from './admin'
import log from './log'

Vue.use(Vuex)

export default new Vuex.Store({
    getters,
    mutations,
    state,
    actions,
    modules: {
        auth: moduleAuth,
        users: users,
        settingCategories,
        groups,
        products,
        shops,
        dealers,
        dashboard,
        cronJobs,
        reports,
        dynamicPricing,
        notifications,
        admin,
        log
    },
    strict: process.env.NODE_ENV !== 'production'
})
